import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {icons} from "../../icons/Icons";

import {ToastLevel} from "../../definitions/CommonDefinitions";

const TIMEOUT = 3 * 1000;

interface ToastElementProps extends JSX.HTMLProps {
	message?: string;
	level?: ToastLevel;
	closeable?: boolean;
}

// Public Definitions -------------------------------------------------------->

@element("flipp-toast")
export class Toast extends Component<ToastElementProps, {}> {

	@attr message: string;
	@attr level: ToastLevel;
	@attr closeable: boolean;

	state = {
		timer: -1,
		visibleMessage: ""
	};

	onAttributeChange(name: string, oldVal: string, newVal: string) {
		// We are manually adding/removing classes to trigger CSS animations
		// Override default behaviour so we don't re-render when classes are changed
		if (name === "message" && newVal !== "") {
			super.onAttributeChange(name, oldVal, newVal);
			this.state.visibleMessage = newVal;
			return;
		}
	}

	invalidate() {
		// Clear the timer before invalidating if it's active;
		if (this.state.timer) {
			clearTimeout(this.state.timer);
		}
		return super.invalidate();
	}

	onRender() {
		if (this.message) {
			this.classList.add("show");
			this.state.timer = setTimeout(() => {
				this.state.timer = -1;
				this.hide_();
			}, TIMEOUT);
		}
	}

	render() {
		if (this.message) {
			return <div
				classList={{
					"error": this.level === "error",
					"warning": this.level === "warning"
				}}
				role="alert"
				flex-horizontal>
				<span flex-vertical>{this.state.visibleMessage}</span>
				{this.closeable ?
					<button class="close" onClick={this.hide_}>
						<span flex-vertical>{icons.x}</span>
					</button>
				:
					null
				}
			</div>;
		} else {
			return null;
		}
	}

	private hide_ = (e?: MouseEvent) => {
		if (e) {
			e.preventDefault();
		}
		if (this.state.timer !== -1) {
			clearTimeout(this.state.timer);
			this.state.timer = -1;
		}
		this.classList.remove("show");
		this.message = "";
	}
}
